import { connect } from 'react-redux';

import * as CommonAction from '../../actions/Common.actions';
import * as UserAction from '../../actions/User.actions';
import MainContainer from './Main.component';

const mapStateToProps = ({ user, auth }) => ({
	user,
	editable: user?.id === auth.id,
});

const mapDispatchToProps = {
	getUserInfo: UserAction.getUserInfo,
	uploadImage: UserAction.uploadImage,
	removeSocialMedia: UserAction.removeSocialMedia,
	removeLink: UserAction.removeLink,
	removeAchievement: UserAction.removeAchievement,
	deleteProfileImage: UserAction.deleteProfileImage,
	showDialog: CommonAction.showDialog,
	editModal: CommonAction.editModal,
	removePhoto: UserAction.removePhoto,
	updateProfile: UserAction.updateProfile,
};

export default connect(mapStateToProps, mapDispatchToProps)(MainContainer);
